import * as requestFromServer from "./serviceProvidersApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";

// service providers -> get service providers api
export const getServiceProvidersAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.getServiceProviders(dataToBeSent);

  if (response) {
    dispatch(
      Actions.createAction(Actions.GET_SERVICE_PROVIDERS_LIST, {
        serviceProviders: response,
      })
    );
    return response;
  }
};

// service providers -> get service providers by id api
export const getServiceProviderByIdAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderById(
      dataToBeSent
    );
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service providers -> get staff members by service providers id api
export const getStaffMemberByServiceProviderIdAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getStaffMemberByServiceProviderId(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_STAFF_MEMBERS_LIST_BY_SERVICE_PROVIDER_ID, {staffMembersList: response}));
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// update service provider status -> update service provider status api
export const updateServiceProviderStatusAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateServiceProviderStatus(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// update service provider status -> update service provider status api
export const updateStatusAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true)
    const response = await requestFromServer.updateStatus(
      dataToBeSent
    );
    if (response) {
      setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null;
    }
  };

// get service provider services -> get service provider services api
export const getServiceProviderServicesAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderServices(
      dataToBeSent
    );

    if (response) {
      setLoading(false);
      dispatch(
        Actions.createAction(Actions.GET_SERVICE_PROVIDER_SERVICES_LIST, {
          serviceProviderServices: response,
        })
      );
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// get service provider offers -> get service provider offers api
export const getServiceProviderOffersAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderOffers(dataToBeSent);

    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_OFFERS_LIST, {serviceProviderOffers: response}));
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// get service provider packages -> get service provider packages api
export const getServiceProviderPackagesAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderPackages(dataToBeSent);

    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_PACKAGES_LIST, {serviceProviderPackages: response}));
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// update service provider services status -> update service provider services status api
export const updateOrganizationServicesStatusAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateOrganizationServicesStatus(
      dataToBeSent
    );
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
